/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

export class TechTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'tech',
            'Technology',
            allLabels.tech,
            { numPairs: 6, ...options }
        );
    }
}
